"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.find");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.from");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.join");

require("core-js/modules/es.array.map");

require("core-js/modules/es.array.reduce");

require("core-js/modules/es.array.slice");

require("core-js/modules/es.function.name");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.string.search");

require("core-js/modules/web.dom-collections.for-each");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _UrlUtils = _interopRequireDefault(require("@icare/core/lib/utils/UrlUtils"));

var _FilterPanel = _interopRequireDefault(require("../FilterPanel"));

var _Spinner = _interopRequireDefault(require("../Spinner/Spinner"));

var _Pagination = _interopRequireDefault(require("../Pagination/Pagination"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * The FilterableListing component
 */
var FilterableListing = /*#__PURE__*/function (_React$Component) {
  _inherits(FilterableListing, _React$Component);

  var _super = _createSuper(FilterableListing);

  function FilterableListing(props) {
    var _this;

    _classCallCheck(this, FilterableListing);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleChangeFilters", function (filters) {
      _this.setState({
        currentFilters: filters,
        currentPage: 1
      }, _this.updateListing);
    });

    _defineProperty(_assertThisInitialized(_this), "handleChangeSort", function (sort) {
      _this.setState({
        currentSort: sort,
        currentPage: 1
      }, _this.updateListing);
    });

    _defineProperty(_assertThisInitialized(_this), "handleChangePage", function (page) {
      _this.setState({
        currentPage: page
      }, _this.updateListing);
    });

    var defaultSortOption;

    if (props.sortCriteria) {
      defaultSortOption = (props.sortCriteria.options || []).find(function (opt) {
        return opt.isDefault;
      });
    }

    _this.state = {
      currentFilters: {},
      currentSort: defaultSortOption ? defaultSortOption.id : null,
      currentPageSize: 10,
      hasInitialised: false,
      isUpdating: false,
      totalResults: null,
      totalPages: null,
      currentPage: null,
      items: null
    };
    return _this;
  }

  _createClass(FilterableListing, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.setState(this.parseQueryString(this.props.location.search), function () {
        _this2.handleUpdate();
      });
    }
  }, {
    key: "doUpdateInternal",
    value: function doUpdateInternal(url) {
      var _this3 = this;

      var search = this.props.history.location.search;

      if (search && search !== url) {
        this.setState(this.parseQueryString(url), function () {
          _this3.handleUpdate();
        });
      }
    }
    /**
     * Manually trigger a change, useful if external filters have updated.
     */

  }, {
    key: "update",
    value: function update() {
      this.handleChangeFilters(this.state.currentFilters);
    }
  }, {
    key: "parseQueryString",
    value: function parseQueryString(query) {
      var _this$props = this.props,
          filters = _this$props.filters,
          sortCriteria = _this$props.sortCriteria;

      var queryParams = _UrlUtils.default.getParamsFromQueryString(query);

      var filterValues = {};
      (filters || []).forEach(function (filter) {
        if (queryParams.hasOwnProperty(filter.id)) {
          var rawVal = queryParams[filter.id]; // If the filter is a checkbox we need to pass in an array

          if (filter.type === 'checkbox' && typeof rawVal === 'string') {
            filterValues[filter.id] = [rawVal];
          } else {
            filterValues[filter.id] = rawVal;
          }
        }
      });
      var sortBy;

      if (sortCriteria && queryParams.hasOwnProperty(sortCriteria.id)) {
        sortBy = queryParams[sortCriteria.id];
      }

      var state = {
        currentPage: parseInt(queryParams.page) || 1,
        currentFilters: filterValues
      };

      if (sortBy) {
        state.currentSort = sortBy;
      }

      return state;
    }
  }, {
    key: "buildUrl",
    value: function buildUrl(page) {
      var params = _objectSpread(_objectSpread(_objectSpread({}, this.state.currentFilters), this.props.externalFilters), {}, {
        page: page || this.state.currentPage
      });

      if (this.props.sortCriteria && this.props.sortCriteria.id) {
        params[this.props.sortCriteria.id] = this.state.currentSort;
      }

      var paramStrings = Object.keys(params).reduce(function (acc, currentParam) {
        var key = currentParam;
        var value = params[currentParam];

        if (Array.isArray(value)) {
          return [].concat(_toConsumableArray(acc), _toConsumableArray(value.map(function (v) {
            return "".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(v));
          })));
        }

        return [].concat(_toConsumableArray(acc), ["".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value))]);
      }, []); // const queryParams = UrlUtils.getParamsFromQueryString(this.props.location.search);
      //
      // debugger;

      return "".concat(this.props.location.pathname, "?").concat(paramStrings.join('&'));
    }
  }, {
    key: "updateListing",
    value: function updateListing() {
      var url = this.buildUrl();
      this.props.history.push(url);
      this.doUpdateInternal(url);
    }
  }, {
    key: "handleUpdate",
    value: function handleUpdate() {
      var _this4 = this;

      this.setState({
        isUpdating: true
      });
      this.props.onRequestUpdate(this.state.currentPage, this.state.currentPageSize, _objectSpread(_objectSpread({}, this.state.currentFilters), this.props.externalFilters), this.state.currentSort).then(function (data) {
        _this4.setState({
          isUpdating: false,
          hasInitialised: true,
          totalResults: data.totalResults,
          totalPages: data.totalPages,
          currentPage: data.currentPage <= data.totalPages ? data.currentPage : 1,
          items: data.items
        }, function () {
          // Make sure that we build the url again in case the values need to change (i.e. current page doesn't exist)
          _this4.props.history.push(_this4.buildUrl());
        });
      }).catch(function (err) {
        _this4.setState({
          isUpdating: false,
          hasInitialised: true,
          items: []
        });

        console.error(err);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this5 = this;

      var _this$props2 = this.props,
          children = _this$props2.children,
          filters = _this$props2.filters,
          sortCriteria = _this$props2.sortCriteria,
          renderItems = _this$props2.renderItems,
          showFilters = _this$props2.showFilters,
          isCompact = _this$props2.isCompact;
      var showPagination = this.state.totalPages > 0 && this.state.totalResults > this.state.currentPageSize;
      var classes = isCompact ? 'filterable-listing filterable-listing--compact' : 'filterable-listing';
      var results = showFilters && this.state.totalResults !== undefined && this.state.totalResults !== null ? /*#__PURE__*/_react.default.createElement("div", {
        className: "filterable-listing__results-message"
      }, "Found ", /*#__PURE__*/_react.default.createElement("b", null, this.state.totalResults), ' ', this.state.totalResults === 1 ? 'result' : 'results') : null;
      return /*#__PURE__*/_react.default.createElement("div", {
        className: classes
      }, /*#__PURE__*/_react.default.createElement(_Spinner.default, {
        active: this.state.isUpdating,
        isStatic: true
      }, results, showFilters && /*#__PURE__*/_react.default.createElement(_FilterPanel.default, {
        filterValues: this.state.currentFilters,
        sortBy: this.state.currentSort,
        filters: filters,
        sortCriteria: sortCriteria,
        onApplyFilters: this.handleChangeFilters,
        onClearFilters: function onClearFilters() {
          return _this5.handleChangeFilters({});
        },
        onApplySort: this.handleChangeSort
      }), /*#__PURE__*/_react.default.createElement("div", {
        className: "filterable-listing__results"
      }, this.state.hasInitialised && typeof renderItems === 'function' ? renderItems(this.state.items, this.state.currentFilters, this.state.currentSort) : children), /*#__PURE__*/_react.default.createElement("div", {
        className: "filterable-listing__footer"
      }, showPagination && /*#__PURE__*/_react.default.createElement(_Pagination.default, {
        linkPage: function linkPage(pageNumber) {
          return _this5.buildUrl(pageNumber);
        },
        pagesToDisplay: 3,
        numberOfPages: this.state.totalPages,
        currentPage: this.state.currentPage,
        onClick: this.handleChangePage
      }))));
    }
  }]);

  return FilterableListing;
}(_react.default.Component);

_defineProperty(FilterableListing, "defaultProps", {
  children: null,
  onRequestUpdate: function onRequestUpdate() {},
  renderItems: null,
  filters: [],
  sortCriteria: null,
  showFilters: true,
  externalFilters: {},
  isCompact: true
});

_defineProperty(FilterableListing, "propTypes", {
  /***
   * Called automatically when the components data should be updated, for example
   * if a filter is applied or pagination is changed.
   *
   * The function provided must return a promise which resolves to the new data.
   *
   * The function provided is called with the following arguments:
   * onRequestUpdate(
   * 		page, 		// current page number
   * 		pageSize,	// current page size
   * 		filters,	// object containing the currently applied filters
   * 		sort,			// the currently applied sort id
   * )
   */
  onRequestUpdate: _propTypes.default.func,

  /***
   * A render prop (see https://reactjs.org/docs/render-props.html) which is called
   * anytime the data/items change.
   *
   * Use this to render the filtered result in anyway you choose.
   *
   * e.g. renderItems={(items) => { return <ul>... the items</ul> }}
   */
  renderItems: _propTypes.default.func,
  showFilters: _propTypes.default.bool,
  filters: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.string,
    title: _propTypes.default.node,
    type: _propTypes.default.oneOf(['radio', 'checkbox', 'picklist', 'multipicklist']),
    options: _propTypes.default.arrayOf(_propTypes.default.shape({
      id: _propTypes.default.string,
      label: _propTypes.default.string,
      value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
    }))
  })),
  sortCriteria: _propTypes.default.shape({
    id: _propTypes.default.string,
    label: _propTypes.default.node,
    options: _propTypes.default.arrayOf(_propTypes.default.shape({
      id: _propTypes.default.string,
      label: _propTypes.default.string,
      value: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
    }))
  }),
  history: _propTypes.default.object.isRequired,
  location: _propTypes.default.object.isRequired,
  children: _propTypes.default.node,
  externalFilters: _propTypes.default.object,
  isCompact: _propTypes.default.bool
});

FilterableListing.defaultProps = {
  children: null,
  onRequestUpdate: function onRequestUpdate() {},
  renderItems: null,
  filters: [],
  sortCriteria: null,
  showFilters: true,
  externalFilters: {},
  isCompact: true
};

var _default = (0, _reactRouterDom.withRouter)(FilterableListing);

exports.default = _default;
//# sourceMappingURL=FilterableListing.js.map